//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TutorialSlide",
  props: {
    header: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: null
    },
    href: {
      type: String,
      default: null
    },
    imgSrc: {
      type: String,
      required: true
    },
    direction: {
      type: String,
      default: "right"
    }
  },
  methods: {
    handleRedirect() {
      window.location = this.href;
    }
  }
});